/* eslint 'no-redeclare': 'off', 'no-loop-func':'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Row,Col, Button, FormGroup, Table } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { GetBuildingMembersList,GetMembersFromFamily,PostZones,SaveZoneDetailsforclient } from '../../../../../../action/ZonesAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SearchInput, {createFilter} from 'react-search-input';

const KEYS_TO_FILTERS = ['objectName'];

class AddZoneForm2 extends Component {

    componentWillMount() {
        var buildingID =   this.props.ClientSideZoneState.Building_ID;
        if(buildingID){
            this.props.GetBuildingMembersList(buildingID);
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            Zone_Name: this.props.ClientSideZoneState.Zone_Name,
            BuildingID : this.props.ClientSideZoneState.Building_ID,
            Building_Name: this.props.ClientSideZoneState.Building_Name,
            FormDisplay:  this.props.ClientSideZoneState.FormDisplay,
            searchTerm: '',
            error:false,
            RowsToMove:[],
            SelectedRows:[],
            MoveRowsRight:false,
            modal: false,
            available_members_in_state:[],
            selected_members_in_state:[]
        };

      this.moveRowsToRight = this.moveRowsToRight.bind(this);
      this.moveRowsToLeft = this.moveRowsToLeft.bind(this);
      this.changeMemberType = this.changeMemberType.bind(this);
      this.handleSubmitZones = this.handleSubmitZones.bind(this);
      this.Back_to_ModalForm1 = this.Back_to_ModalForm1.bind(this);
      this.CloseModal = this.CloseModal.bind(this);
      this.searchUpdated = this.searchUpdated.bind(this);
      this.comparer = this.comparer.bind(this);
      }

     
    changeMemberType(){
        this.setState({MoveRowsRight:false  });
        
        var selectoption = document.getElementById("MemberSelectoption");
         var familyId = selectoption.options[selectoption.selectedIndex].value;
         if(familyId=="ShowAll"){
            this.props.GetBuildingMembersList(this.props.ClientSideZoneState.Building_ID);
         }
         else{
            this.props.GetMembersFromFamily(this.state.BuildingID,familyId);
         }
    }


    componentWillReceiveProps(nextProps) {
        if(this.props != nextProps) {
                this.setState({available_members_in_state : nextProps.Response_of_MembersCall.MembersList  });
        }
      }



    moveRowsToRight() {
        var RowstobeMoved_SM = [];
       //var RowstobeMoved_Left = [];

        if(this.state.selected_members_in_state.length>0){
            var RowstobeMoved_SM = this.state.selected_members_in_state;
        }
        var checkboxes = document.getElementsByClassName('Available_members_left');

        for (var i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked === true){
                var x = checkboxes[i].id;
                 var MembersArray= this.state.available_members_in_state;
                 var obj = MembersArray.filter(function (obj) { return obj.objectId == x })[0];
                 RowstobeMoved_SM.push(obj);
            }
        }
        this.setState({selected_members_in_state:RowstobeMoved_SM });
        
    }

    moveRowsToLeft() {
        var RowstobeMoved_SM = [];
        
        var checkboxes = document.getElementsByClassName('Available_members_right');
        for (var i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked === false){
                var x = checkboxes[i].id;
                 var MembersArray= this.state.selected_members_in_state;
                 var obj = MembersArray.filter(function (obj) { return obj.objectId == x })[0];
                 RowstobeMoved_SM.push(obj);
            }
        }
        this.setState({selected_members_in_state : RowstobeMoved_SM });
    }


   //Closing the modal
    CloseModal()  {
        var resetmodaldata = {
            "FormDisplay"  : true
        }
        this.props.SaveZoneDetailsforclient(resetmodaldata);
        this.props.closeModalPopUp("close");
     }

   //Back to modal 1 form
    Back_to_ModalForm1(){
        var resetmodaldata = {
            "Zone_Name"  : this.state.Zone_Name,
            "Building_ID"  : this.state.BuildingID,
            "Building_Name"  : this.state.Building_Name,
            "FormDisplay"  : true
         }
           this.props.SaveZoneDetailsforclient(resetmodaldata);
    }

    //Finish or Submit records to data base 



    handleSubmitZones(){

        var selectedRecords = this.state.selected_members_in_state;
      
        if(selectedRecords.length>0){
            this.setState({ SelectedRows: selectedRecords },()=>{
                var data = {
                    "zoneName": this.state.Zone_Name,
                    "buildingId": this.state.BuildingID,
                    "members": this.state.SelectedRows
                    }
            
            this.props.PostZones(data);
            var resetmodaldata = {
                "Zone_Name"  : "",
                "Building_ID"  : "",
                "Building_Name"  : "",
                "FormDisplay"  : true
             }
               this.props.SaveZoneDetailsforclient(resetmodaldata);
               this.props.closeModalPopUp("close");
            });
        }
        else{
            this.setState({
                error: true
            });
            return;
        }
    }

     comparer(otherArray){
if(otherArray.length>0){
        return function(current){
          return otherArray.filter(function(other){
            return other.objectId == current.objectId && other.objectName == current.objectName
          }).length == 0;
        }
    }
    } 

    render(ClientSideZoneState, Response_of_MembersCall, getLabels) {

        let data,data2, modal_form_2, Available_members,Selected_Members,FilteredData;

           data = this.state.available_members_in_state;
           data2 = this.state.selected_members_in_state;
        let label = this.props.getLabels;

           if (data != undefined && data.length > 0 && data != null) {
                 if(data2.length ==0){
                    FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                    if (FilteredData.length != 0) {
                    Available_members = FilteredData.map(el => (
                        <tr id={el.objectId} className="RightTablerecords" key={el.objectId}><td><input type="checkbox" id={el.objectId} className="Available_members_left" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_left","available_members_header_Check_box"); }}/></td>
                                <td id={el.objectId}>{el.objectName}</td></tr>
                        ));
                    }
                    else {
                        Available_members = <tr><td>{label['NoRecords.Text']}</td></tr>
                    }
                 }
                 else{

                    var Available_members_Data = this.state.available_members_in_state;
                    var Selected_Members_Data = this.state.selected_members_in_state;
                
                
                var AM = Available_members_Data.filter(this.comparer(Selected_Members_Data));
                
                     FilteredData = AM.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                     if (FilteredData.length != 0) {
                    Available_members = FilteredData.map(el => (
                        <tr id={el.objectId} className="RightTablerecords" key={el.objectId}><td><input type="checkbox" id={el.objectId} className="Available_members_left" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_left","available_members_header_Check_box"); }}/></td>
                                <td id={el.objectId}>{el.objectName}</td></tr>
                        ));
                    }else {
                        Available_members = <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
                    }
            
                        
                        Selected_Members = Selected_Members_Data.map(el => (
                            <tr id={el.objectId} className="RightTablerecords" key={el.objectId}><td><input type="checkbox" id={el.objectId} className="Available_members_right" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_right","selected_members_header_Check_box"); }}/></td>
                                    <td id={el.objectId}>{el.objectName}</td></tr>
                            ));
                 }
           }
           else {
            Available_members = <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
        }
 



            // validations
            if(this.state.error){
                var errormsg =   <p  className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" /> 
                {label['CheckTemperatureAdjustment.Text'] !== undefined ? label['CheckTemperatureAdjustment.Text'] : "Error: You left necessary fields blank or entered invalid values."}
                </p> 
              }
                
                               modal_form_2 =    <div className="">


                                                    <h4 className="Modal_form_title">{label['TenantZones.AddZone.Text'] !== undefined ? label['TenantZones.AddZone.Text'] : "Add New Zone"}</h4>
                                                    
                                                    <div className="Modal_form_group ">
                                                        <label className="Modal_label"><b>{label['TenantZones.Name.Text'] !== undefined ? label['TenantZones.Name.Text'] : "Name"}</b></label> <label className="zoneFieldStyle Modal_label" style={{height:'auto'}}>{this.state.Zone_Name}</label>
                                                    </div>

                                                    <div className="Modal_form_group " style={{clear: 'both'}}>
                                                        <label className="Modal_label"><b>{label['TenantZones.Building.Text'] !==  undefined ? label['TenantZones.Building.Text'] : "Building"}</b></label><label className="zoneFieldStyle Modal_label">{this.state.Building_Name}</label>
                                                    </div>
                                                    <div className="Modal_sublabel_group">
                                                        <label className="Modal_label"><b>{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}</b></label>
                                                    </div>
                                                    <div>
                                                    </div>

                                                    <div className="Modal_form_group ">
                                                        <label className="Modal_label">{label['TenantZones.ShowOnly.Text'] !== undefined ? label['TenantZones.ShowOnly.Text'] : "Member Type"}</label>
                                                        <select ref='Building_in_Select_input' className="Modal_input_regular " id="MemberSelectoption" onChange={() => { this.changeMemberType(); }} style={{"width":"150px","marginRight":"50px"}} >
                                                            <option value="ShowAll" >{label['TenantZones.ShowAll.Text'] !== undefined ? label['TenantZones.ShowAll.Text'] : "Show All"}</option>
                                                            <option id="1" value="1">{label['TenantZones.Spaces.Text'] !== undefined ? label['TenantZones.Spaces.Text'] : "Spaces"}</option>
                                                            <option id="11" value="11">{label['TenantZones.Areas.Text'] !== undefined ? label['TenantZones.Areas.Text'] : "Areas"}</option>
                                                            <option id="7" value="7">IO-BinaryPoints</option>
                                                        </select>
                                                    <SearchInput  onChange={this.searchUpdated}  />
                                                        
                                                        
                                                    </div>
                                                    <div>
                                                    {errormsg}
                                                    </div>

                                                    <Row >
                                                        <Col sm={{ size: 4 }}>
                                                        <div className="members_left_table" style={{overflowX:"auto",maxHeight:"300px"}}>
                                                            <Table striped responsive className="Custom_table right_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th><input type="checkbox" className="available_members_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Available_members_left","available_members_header_Check_box"); }} /></th>
                                                                        <th>Available_Members </th>
                                                                    </tr>
                                                                    {Available_members}
                                                                </thead>
                                                            </Table>
                                                            </div>
                                                        </Col>
                                                        <Col sm={{ size: 2,offset: 1 }}>
                                                            <Button className="btn-black btn-md AddZone_Addbtn" onClick={() => { this.moveRowsToRight(); }} > {label['TenantZones.btnMembersAdd.Text'] !== undefined ? label['TenantZones.btnMembersAdd.Text'] : "Add >"}</Button>
                                                            <Button className="btn-black btn-md AddZone_Removebtn" style={{"margin-top": "5%"}} onClick={() => { this.moveRowsToLeft(); }}  >{label['TenantZones.btnMembersRemove.Text'] !== undefined ? label['TenantZones.btnMembersRemove.Text'] : "< Remove"}</Button>
                                                        </Col>
                                                        <Col sm={{ size: 4,offset: 1 }}>
                                                        <div className="members_right_table" style={{overflowX:"auto",maxHeight:"300px"}}>
                                                            <Table striped responsive className="Custom_table left_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th><input type="checkbox"className="selected_members_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Available_members_right","selected_members_header_Check_box"); }} /></th>
                                                                        <th>Selected_Members </th>
                                                                    </tr>

                                                                    {Selected_Members}

                                                                </thead>
                                                            </Table>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                    <FormGroup row className="btns_group">
                                                        <Col sm={{ size: 10 }}>
                                                            <Button className="btn-gray btn-md"  onClick={this.CloseModal}> {label['TenantZones.Cancel.Text'] !== undefined ? label['TenantZones.Cancel.Text'] : "Cancel"} </Button>
                                                            <Button className="btn-gray btn-md" onClick={() => { this.Back_to_ModalForm1(); }} >{label['TenantZones.btnBackSelection.Text'] !== undefined ? label['TenantZones.btnBackSelection.Text'] : "< Back "}</Button>
                                                            <Button className="btn-success btn-md"  onClick={() => { this.handleSubmitZones(); }} >{label['TenantZones.btnFinish.Text'] !== undefined ? label['TenantZones.btnFinish.Text'] : "Finish"}</Button>
                                                        </Col>
                                                    </FormGroup>
                                                </div>
        

        return ( <div> {modal_form_2} </div> );
    }
    searchUpdated (term) {
        this.setState({searchTerm: term})
      }
}


const mapStateToProps = state => {
    return {
        ClientSideZoneState: state.zonesRootReducer.ClientSideZonesData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        Response_of_MembersCall: state.MembersRootReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetBuildingMembersList: (buildingid) => dispatch(GetBuildingMembersList(buildingid)),
        GetMembersFromFamily: (buildingid,familyId) => dispatch(GetMembersFromFamily(buildingid,familyId)),
        PostZones: (data) => dispatch(PostZones(data)),
        SaveZoneDetailsforclient: resetmodaldata => dispatch(SaveZoneDetailsforclient(resetmodaldata)),
        closeModalPopUp: (data) => dispatch(closeModalPopUp(data)),
        

        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddZoneForm2);
            



